require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/fn/object/set-prototype-of.js
// module id = 963
// module chunks = 0 1